module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("WIDE WORLD")])])]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("My family still owns a restaurant and we still call it “The Store,” but it is not “The Store” in my heart.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("The one in my heart has a Dutch door and a tiled stoop, surrounded by the sound of roll-down gates with locks and pegs being thrown in a bucket. I am small and dirty with hair my mom calls “the rat’s nest.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("My twin sister, Minda, has an identical “nest.” We step barefoot on tables and take naps in vinyl booths. Charlie, Danny, and Zack, my three brothers, spin on stools and crawl on the floor. Two ceiling fans whirl above covered in dust clumps held together by grease.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("And Willoughby stands by the door. He looks cool, even with roast beef hanging from his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("The Store is on the corner of Morton and Bedford Streets in Greenwich Village. And it is still a village.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Everyone knows who we are. Teachers let us say “shit” in class and show up an hour late. “It’s not Zack’s fault,” the real teacher advises the substitute teacher. “He is a Shopsin.”")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("We drag cups across the plastic levers of our family soda fountain and make murder cocktails that contain every flavor.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIL"
  }, [_vm._v("Customers bring our parents candy and toys from all over the world. The customers are matter-of-fact the best people in New York. New York is matter-of-fact the best place on earth.")]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Barely 8, my brother Charlie had the day off from school. He told my mom that he wanted to go to the Museum of Natural History. She gave him ten dollars and explained how to take the train to 81st Street. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Charlie crossed the avenue and made his way to the subway. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("At the West 4th Street station he paid his token and went to the uptown platform. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("But he caught the A train and it didn’t stop at 81st. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("It didn’t stop at 86th or 96th or 103rd. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Charlie got off the train and found a payphone on the platform. It cost a dime.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("“Hey, Mom, I’m in Harlem. I’m on 125th Street,” Charlie said.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("My mom didn’t freak out. She told him to go to the downtown side and catch the local C train.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("And that is what Charlie did.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("At the museum he saw dinosaurs, ran the ramps of the carpeted gem room, ate lunch at the cafeteria, and bought a ruler in the gift shop. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("And then he took the train home.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Home was The Store. My mom was not waiting on a nervous edge for Charlie. She was waiting on tables.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("When me and my twin sister were older, maybe 11, we would cover shifts for my mom; say, if she needed to go for a parent-teacher meeting. This was always because she had five kids.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Minda was much better at waitressing than me, but we got to split the tips evenly. The tips were huge. We had passbook checking accounts and credit cards.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Whenever my mom was pregnant she’d rub her belly and sing that The Store was about to get a new dishwasher.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("On TV I saw kids complain to their parents about doing the dishes and I’d think: fuck, they’re only washing one cover, two at most. My brother Danny never complained and he worked whole shifts, whole summers.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("He never complained even though I cleared tables like a thoughtless prick, throwing half-full glasses in the bus tray, filling it with a mix of soda and beer.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("He did spray me.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("None of us thought of working at The Store as a chore. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("My dad was the cook. Customers came to talk to him and my mom as much as to eat. It was a forum of philosophy and hot sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIL"
  }, [_vm._v("Then there was Willoughby, Willy, whose mystery is the reason for this book.")]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("On Mother’s Day Willy would poke his head in The Store’s double door, a hanger wrapped around his neck. This was his way of celebrating the holiday.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Tic-tac-toe was a quarter a game. Me and Minda were allowed to go into my mom’s tip cup for it. Sometimes Willy would let me win, but usually we tied. We played it every day until he taught me craps. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIL"
  }, [_vm._v("Willy taught my father to curse. If you ever met my dad you know what an achievement that is. ")]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "IMG1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "227",
      "src": "images/847590038_bwcrop.jpg",
      "width": "350"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP"
  }, [_vm._v("My dad")]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Albert was a communist, a sailor, and a superintendent. He and my dad were friends and would hang out at a diner on Sheridan Square called Riker’s. They’d do the crossword puzzle and eat pastries. This was before The Store and before my mom. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("My dad was lost. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Albert suggested he become a super because you didn’t have to do much and you got free rent. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("So my dad became the live-in super of 38 Morton Street.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("In New York at the time, if you had more than five units in a building you needed a live-in super. There was a loophole. You could hire a super that lived within five hundred feet of the building, known as a traveling super. So my dad picked up two more buildings—one on Seventh Avenue and another on Morton Street.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIL"
  }, [_vm._v("Willy hung around Riker’s, too, but at that point, Dad didn’t really know him. ")]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("It was hard to really know Willy.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("He was black, but his skin was silver-white. As a graphic designer now, I can see it as a 10% tint of black. He had a deep voice made for singing without a microphone, and always wore a newsboy cap. He was a senior citizen by the time I was born. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("When my oldest brother, Charlie, was little, Willy dubbed him “The Reverend Chuckie Joe” and tried forever to turn him into a boy televangelist. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("“But, Willy, I’m Jewish,” Charlie would say.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("That’s better, you a sinner but you seen the light")]), _vm._v(", Willy would reply.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("The weekly deposits for The Store were made by Willy. He’d set off with a wad of twenties wrapped in a rubber band and a deposit slip. If there were more twenties than the amount on the slip, Willy got to keep the money.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIL"
  }, [_vm._v("My mom and dad would mess up now and then. Willy would come back from the bank singing and buy me and my twin sister scratch-off Lotto tickets to celebrate. ")]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("My parents put the extra twenties in on purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Mom had no problems with us seeing movies rated PG-13, R, even NC-17. But the skinny dude who worked at the Waverly Theater gave not a shit about what Mom thought, rule is a rule: an adult must accompany you if a movie has a rating above PG. All the movies my brothers wanted to see were above PG.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Willy would take them to see whatever film they wanted. It didn’t feel like he was doing them a favor. It felt like a friend, even if they were seeing "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Airborne")]), _vm._v(", a movie whose action sequences involved teenagers rollerblading through Cincinnati. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("When it snowed, me and my siblings helped shovel and salt the sidewalk. Not just The Store’s sidewalk, but also the sidewalks of the buildings that Willy took care of.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("It was Morton Street. That was how my dad and Willy got close. They were both live-in supers. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Very early in my dad’s relationship with Willy, they were walking down Morton Street. A man stopped them. “Do you know Willoughby?” the man asked.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Nope, never heard of him")]), _vm._v(", Willy answered.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIL"
  }, [_vm._v("Time spent with Willy was a lesson. My dad doesn’t really know who made the first move in their friendship, but it is safe to assume it wasn’t Willy.")]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("World Wide Photo was an image bank and photo-assignment agency. In the 1960s, Willy was looking them up in the phone book. He swapped the name by mistake, searching for Wide World Photo. There was no listing. So he called up the Yellow Pages, bought Wide World Photo, and put his number and address next to it. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("In the background of his life, he fielded calls for Wide World. Image requests would come in, he’d turn around and call World Wide, buying the image at a lower rate. He kept popular images on hand.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIL"
  }, [_vm._v("Willy was, in a way, an artist. He would rather steal ten cents than earn ten dollars.")]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("I found an old stack of photos of the Pope once when I was dropping lunch off at Willy’s apartment. It was strange and kind of scared me, because normally I would find photos of tits and ass. I asked my dad, and that’s when he told me about Wide World.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIL"
  }, [_vm._v("Wide World would get calls for photo assignments, too. Assignments to photograph people like Nelson Rockefeller or Cardinal Spellman. My dad would go as Willy’s assistant. They’d make fake press passes and have a good time. Willy was a decent photographer. He kept a darkroom in his apartment and had a friend with a stat camera.")]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("My husband, Jason, is a photographer. Some of our first dates were photo jobs where I tagged along as his assistant. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Ever since, I have thought about the Wide World Photo assignments as my dad and Willoughby going out on first dates.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("“Ha’yah, mule,” Jason would say as I lugged the Profoto pack and light stands. The equipment weighed fifty pounds.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Often I’d get out of balance and crouch so the floor held the burden. Jason would shift the straps and secretly kiss my neck.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIL"
  }, [_vm._v("This was on the way to shoot things like an animatronic gorilla, the world’s largest algae library, a magic trick distributor, the inside of a wind turbine, and the undefeated cookie champions of the Iowa state fair.")]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "IMG1",
    attrs: {
      "id": "fig2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "500",
      "src": "images/316880_4_5_BW.jpg",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP"
  }, [_vm._v("Photograph by Jason")]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("I don’t know how long Willy’s scam went on, but I know how it ended. An accounting agency sent a check meant for World Wide worth $21,000 to Wide World’s address, and Willy cashed it. World Wide found out. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Caught, Willy said he would give the money back and then sell them Wide World’s Yellow Pages listing.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIL"
  }, [_vm._v("World Wide said Willy would give the money AND listing back. So he gave both back, and that was that.")]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Willy was in more than one way an artist. He used to sing at nightclubs. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIL"
  }, [_vm._v("I wish I could say more, but my dad never went to see Willy sing. That was a separate life. Their life was Morton Street.")]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("A neighborhood guy named Roscoe gave my dad an old safe. The kind you drop on someone in a silent comedy. We still have this safe. Me and my twin sister’s first passports are kept in it. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Roscoe had the safe for fifty years but didn’t know the combination. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Willy had a friend that was a safecracker. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("The safecracker comes. He sees the safe and right off says the last number of this kind is always 17, then zippy-dippy he opens the safe faster than my dad can open it to this day.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Willy had an assortment of friends like that. People who could get you guns. People who could get you drugs. He liked running with dangerous people but had a theory he lived by: ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIL"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Don’t sit next to people like that. Someone might come to shoot them, miss, and get you instead.")])]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "IMG-break"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "519",
      "src": "images/umpireink3.jpg",
      "width": "300"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("The main perk of being a super is not paying rent.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Willy lived in an illegal apartment in the basement of his building.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("It wasn’t a free ride. Willy worked. He swept the halls, took care of boilers and rats. He was mechanically gifted, with a full set of tools and a never-ending list of requests.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("If there was a plumbing problem Willy knew when it was an easy fix and when it was time to call Garboli’s.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Garboli was a drunk mess, and he was expensive. But he was better than Two Time Ralph, who no matter what he fixed would need to come back again. Plus Garboli had a plumber named Chris. A thin, sweet guy, Chris would ride over on his bike as soon as you called. There was another good plumber that worked for Garboli named Philip.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIL"
  }, [_vm._v("Willy and my dad always hoped to get Chris, but were happy as long as Garboli himself didn’t show up. ")]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("The basement apartment had its own entrance and was sort of hidden. Willy would let people use it as a tryst spot for secret love affairs. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("One morning Willy woke up and found a gun dropped in his window. He took it apart and dumped it in the river.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Memphis was a friend you didn’t sit next to. Willy never let him near my dad. If Willy was talking to Memphis my dad circled the block. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Memphis wouldn’t drop a gun in Willy’s window if he wanted it back.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("But one of Memphis’s lackeys would. When the kid came looking for the gun Willy chewed him out.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Fucking shit. You don’t dump no gun in my house without telling me.")])]), _vm._v(" "), _c('p', {
    staticClass: "TNIL"
  }, [_vm._v("When Willy told this story to my father it was long, lyrical, and involved two women. Nuances like that are now lost to time. ")]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Willy never had to pay for drinks; he would just sing a set at a club or be treated by someone. And he didn’t pay for other things, because people owed him for the use of his love nest. He learned to survive in the city like an Indian lives off the land.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIL"
  }, [_vm._v("“The nutrients of New York City are in the fringe people.” I was brought up to believe this, and that the definition of a fringe person was Willoughby. ")]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Willy was born in St. Louis. His mother had tried to abort him and ran off as soon as she could. He was raised by his dad, who worked for the railroad. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("As a kid Willy got a lot of shit for being light-skinned. An ungodly amount. I think his dad was black and his mom was a mix. There must have been some Irish, because he had red hair. I can’t confirm this, because I only knew him with gray tiny curls. But he would tell me about getting the crap kicked out of him. He must have looked pretty freaky, because as a person Willy was the least contentious human on the planet.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("A blind woman named Annie lived in Willy’s building. Annie baked these fluffy muffins. She always gave a few to Willy because he helped her out and because he loved them.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("One day Willy is over at her apartment. She is baking the muffins and measures out the ingredients. There are hundreds of bugs and weevils crawling in not just the flour but the sugar, too.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIL"
  }, [_vm._v("He never told Annie about the bugs. He just continued to eat the muffins. And he loved the muffins just the same. ")]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("But when pushed, Willy would get tough. His father had taught him to fight back.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Willy didn’t know where to begin.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("There were so many kids that beat him up.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Start with the biggest, scariest one, was his father’s advice.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("A boy named Arvell was twice anyone’s size. One day Willy walks by Arvell and baits him into a fight. As soon as Arvell swings, Willy hits him in the shin with a copper pipe.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Willy didn’t win the pipe fight. But he won the war: no one bothered him after that. For the rest of his life he didn’t take crap from anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("He taught it to my dad, and he taught it to me:")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Stand up to that cocksucking bully. No shit if you lose. As long as it ain’t a free ride, that motherfucker, all those motherfuckers, will let you be.")])]), _vm._v(" "), _c('p', {
    staticClass: "TNIL"
  }, [_vm._v("Later Arvell and Willy became friends, and that made double sure no one messed with him. ")]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("When he moved to New York, Willy brought a wife. She was beautiful, but a compulsive gambler who would fuck other guys, and eventually did too much coke. I never met her. I never met any of Willy’s ladies. Separate life.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("Willoughby loved pussy. There is nothing more in this wide world he loved more than pussy. It is just a fact. ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("My dad told me Willy once had a girl over. The girl and Willy had lots of sex and drinks. And he gave her his television set.")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_vm._v("When Willy wanted to get laid he gave everything away. He had an expression: ")]), _vm._v(" "), _c('p', {
    staticClass: "TNIS"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("When I’m hard I’m soft and when I’m soft I’m hard.")])]), _vm._v(" "), _c('p', {
    staticClass: "TNIL"
  }, [_vm._v("And it was true, because the next day Willy went and got the television back. ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ac7106","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 75
// module chunks = 0